/**
 * @generated SignedSource<<ef645bbefdce5d09a1698b25850da6c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetFilePage_page$data = {
  readonly id: string;
  readonly image: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
  } | null;
  readonly " $fragmentType": "WidgetFilePage_page";
};
export type WidgetFilePage_page$key = {
  readonly " $data"?: WidgetFilePage_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetFilePage_page">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetFilePage_page",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Image_image"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FilePage",
  "abstractKey": null
};
})();

(node as any).hash = "c0ef25bcb3b0b3f31abc190c661cf581";

export default node;
